/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, {
	type NotificationsPageQuery,
} from '@jira/personal-settings__notifications/src/ui/__generated__/NotificationsPageQuery.graphql';

type AccountId = string;

// Queries your component uses
type Queries = { pageAndProject: NotificationsPageQuery };

// Props from your EntryPoints definition you wish to pass to your component
type ExtraProps = {
	accountId: AccountId | null;
};

type PersonalSettingsNotificationsEntryPointComponent = EntryPointComponent<
	Queries,
	{},
	{},
	ExtraProps
>;

export const personalSettingsNotificationsEntryPoint: EntryPoint<
	PersonalSettingsNotificationsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<PersonalSettingsNotificationsEntryPointComponent>(
		/* webpackChunkName: "async-personal-settings-notifications" */ './PersonalSettingsNotificationsPageDefault.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		// Queries your async component uses
		queries: {
			pageAndProject: {
				options: {
					fetchPolicy: 'network-only' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : [],
				},
			},
		},
		// Optional - Anything extra you wish to pass to your component
		// Something from `EntryPointParams` for example
		extraProps: {
			accountId: tenantContext.atlassianAccountId,
		},
	}),
});
